import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Theme, Box } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { localStorage } from 'react-storage'
import { Linq } from '@src/components/Linq'
import { documentTypeMapper } from './certificateUtils'

type NoDocumentationFoundProps = {
  documentType: string
  productNumber: string
}

export const useStyles = makeStyles((theme: Theme) => ({
  noDocumentationAvailable: {
    marginBottom: theme.spacing(3),
  },
}))

export const NoDocumentationFound: FC<NoDocumentationFoundProps> = ({
  documentType,
  productNumber,
}) => {
  const abbrevDocType = documentTypeMapper[documentType].abbrev
  const docType = documentTypeMapper[documentType].name
  const classes = useStyles()

  return (
    <Box data-testid="no-documentation-found">
      <Typography className={classes.noDocumentationAvailable} variant="body2">
        <FormattedMessage
          id="IT_LOOKS_LIKE_RUN_INTO_PROBLEM"
          defaultMessage={
            "It looks like we've run into a problem, but you can still download {docType} from our"
          }
          values={{ docType }}
        />{' '}
        <Linq
          href={`/documents-search?tab=${abbrevDocType.toLowerCase()}`}
          onClick={() =>
            localStorage.setItem('pdpProductNumber', productNumber)
          }
        >
          <FormattedMessage id="DOCUMENTS" defaultMessage="Documents" />
        </Linq>{' '}
        <FormattedMessage id="SECTION" defaultMessage="section." />
      </Typography>

      <Typography variant="body2">
        <FormattedMessage
          id="IF_YOU_NEED_ASSISTANCE"
          defaultMessage="If you need assistance, please contact"
        />{' '}
        <Linq href="/support/customer-support">
          <FormattedMessage
            id="CUSTOMER_SUPPORT"
            defaultMessage="Customer Support"
          />
        </Linq>
      </Typography>
    </Box>
  )
}
